<template>
  <div>
    <!-- Bid ID Parsing -->
    <div class="form-group m-b-15" v-if="enableBidIdParsing">
      <label class="control-label col-md-3 col-sm-3">
        {{ $t('PING_TREE_TARGET_BID_ID_PARSING') }}
        <i
          v-tooltip.right="$t('PING_TREE_TARGET_BID_ID_PARSING_TT')"
          class="fa fa-question-circle m-l-5"
        />
      </label>
        <div class="display-flex m-b-10 col-md-9">
            <SearchableDropdown
              v-model="bidIdParsing[0].property"
              class="m-r-15 m-b-10 input--size-md"
              :config="selectablePropertiesConfig"
              :clearable="false"
              rules="required"
              name="bidIdParsingSettings"
              @change="updateBidIdParsingSettings"
            />
            <label 
                v-t="'REQUIRED'"
                class="form-group__label-required"
              />
        </div>
      </div>
  </div>
</template>
<script>
import messages from '../locales';
import sharedMessages from '@/core/locales';
import { acceptanceParsingComparisonConfig } from '@/modules/dynamicInboundCalls/helpers/constants';
import SearchableDropdown from '@/core/components/SearchableDropdown/SearchableDropdown';

export default {
  name: 'BidIdParsingSettings',
  components: {
    SearchableDropdown
  }, 
  props: {
    bidIdParsing: {
      type: Array,
      default() {
        return [];
      },
    },
    selectablePropertiesConfig: {
      type: Object,
      default() {
        return {};
      },
    },
    enableBidIdParsing: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.acceptanceParsingComparisonConfig = acceptanceParsingComparisonConfig;
  },
  methods: {
    updateBidIdParsingSettings() {
      this.$emit('updateBidIdParsingSettings');
    },
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  } 
};
</script>